import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ConsumedData } from '.';

export class StoreConsumptionReportResponse extends GlobalResponseObject {
    data?: ConsumedData[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ConsumedData[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}